/** Absolute site origin, including the deployment base path when present. */
export function getSiteOrigin(): string {
  const basePath = __BASE_PATH__.split("/").filter(Boolean).join("/");
  const pathPrefix = basePath ? `/${basePath}` : "";
  return `${window.location.origin}${pathPrefix}`;
}

/** Full URL used as the Supabase Auth email redirect (PKCE code exchange target). */
export function getCallbackUrl(next?: string): string {
  const url = `${getSiteOrigin()}/auth/callback`;
  if (!next) return url;
  return `${url}?next=${encodeURIComponent(next)}`;
}

const AUTH_ROUTE_PREFIXES = ["/auth", "/admin/login"];

/**
 * Validates a post-auth destination for ordinary (non-recovery) sign-in flows.
 * Only same-origin internal paths are accepted; auth routes and malformed values fall back.
 */
export function validateOrdinaryPostAuthNext(raw: string | null): string {
  const fallback = "/admin/panel";
  if (!raw) return fallback;
  const value = raw.trim();
  if (!value.startsWith("/") || value.startsWith("//")) return fallback;
  if (value.includes("://")) return fallback;
  if (AUTH_ROUTE_PREFIXES.some((prefix) => value === prefix || value.startsWith(`${prefix}/`))) {
    return fallback;
  }
  return value;
}